namespace AgerLMS {
    export enum LessonFileTypes {
        Video = 0,
        Pdf = 1,
        PowerPoint = 2,
        Sound = 3,
        Image = 4,
        Archive = 5,
        Document = 6,
        Project = 7
    }
    Serenity.Decorators.registerEnumType(LessonFileTypes, 'AgerLMS.LessonFileTypes');
}
